module.exports = __webpack_public_path__ + "img/635@2x.1402f8c2.png";